//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RestaurantGeneralInfo from '@/components/dashboard/wp-dashboard/RestaurantGeneralInfo'
import RestaurantInputFields from '@/components/dashboard/wp-dashboard/RestaurantInputFields'
import RestaurantMenuManager from '@/components/dashboard/wp-dashboard/RestaurantMenuManager'

export default {
    data() {
        return {
            menuDialog: false,
        }
    },
    components: {
        RestaurantGeneralInfo,
        RestaurantInputFields,
        RestaurantMenuManager,
    },
}
